<template>
<div>
  <nav-bar></nav-bar>
  <div class="container pading pt-16">
    <div class="row gray-bg pt-5">
      <div class="col-12 col-md-8  font-18 p-5 text-right">
        <h3 class="secondary-text pb-5 text-right">{{ $getText("ABOUT-ISOKIA") }}</h3>
        {{ $getText("TITLE-ISOKIA") }}
        <div class=" text-center pt-10">
          <i class="fa-brands fa-facebook-f  font-30 px-3 secondary-text"></i>
          <i class="fa-brands fa-instagram  font-30 px-3 secondary-text"></i>
          <i class="fa-brands fa-twitter  font-30 px-3 secondary-text"></i>
        </div>
      </div>
      <div class="col-12 col-md-4 p-5">
        <img src="../assets/img/academic.png" class="img-fluid " alt="academic">

        <img src="../assets/img/Isokia.png" class="img-fluid " alt="Isokia">

        <img src="../assets/img/iranzillow.png" class="img-fluid " alt="iranzillow">
      </div>
    </div>
  </div>
  <div class="container-fluid secondary-bg">
    <div class="row  mx-12 mt-4 py-10">
      <div class="col-6 col-md-3 col-lg-2 mx-auto" v-for="(item,i) in isokia" :key="i">
        <a :href="item.path" target="_blank">
          <img :alt="item.name" :src="getImgUrl(item.src)" class="mx-auto border-btn img-fluid p-3 gray-bg">
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import NavBar from "@/components/NavBar";
export default {
  name: "IsokiaKashani",
  metaInfo: {
    title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-ایزوکیا'
  },
  components: {NavBar},
  data: () => ({
    isokia: [],
  }),
  mounted() {
    this.isokia = this.$getisokia();
    this.$setCssFiles();
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    }
  },
}
</script>

<style scoped>

</style>
